import { render, staticRenderFns } from "./KnowledgeGraph.vue?vue&type=template&id=5d37289b&"
import script from "./KnowledgeGraph.vue?vue&type=script&lang=js&"
export * from "./KnowledgeGraph.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports